import React from 'react';
import ProCalculatorProvider from '../contexts/ProCalculatorContext';
import { useProCalculator } from '../hooks/useProCalculator';
import ReferenceSection from './ReferenceSection';
import CookieRowsSection from './CookieRowsSection';
import SetsSection from './SetsSection';
import DimensionsSection from './DimensionsSection';
import ColorsSection from './ColorsSection';
import OrdersSection from './OrdersSection';
import ResultsSection from './ResultsSection';
import CookieImageAnalyzer from './CookieImageAnalyzer';
// import ProjectManager from './ProjectManager'; // Hide Project Manager for now
import '../styles/ProCalculator.css';

// Inner component that uses the context
const ProCalculatorContent = () => {
  const { 
    isSectionVisible, 
    showImageAnalyzer, 
    currentAnalyzingRow, 
    setShowImageAnalyzer,
    handleImageProcessed
  } = useProCalculator();

  return (
    <div className="pro-calculator-content">
      {/* Cookie Image Analyzer Modal */}
      {showImageAnalyzer && currentAnalyzingRow && (
        <div className="modal-overlay">
          <div className="modal-content">
            <CookieImageAnalyzer
              onImageProcessed={handleImageProcessed}
              maxWidth={parseFloat(currentAnalyzingRow.width) || 0}
              maxLength={parseFloat(currentAnalyzingRow.length) || 0}
              onClose={() => setShowImageAnalyzer(false)}
            />
          </div>
        </div>
      )}
      
      {/* Calculator sections - We no longer need the SectionSelector here as it's in the sidebar */}
      {isSectionVisible('reference') && <ReferenceSection />}
      {isSectionVisible('cookieNames') && <CookieRowsSection />}
      {isSectionVisible('sets') && <SetsSection />}
      {isSectionVisible('dimensions') && <DimensionsSection />}
      {isSectionVisible('colors') && <ColorsSection />}
      {isSectionVisible('orders') && <OrdersSection />}
      {isSectionVisible('results') && <ResultsSection />}
      
      {/* Hide Project Manager for now */}
      {/* {user && <ProjectManager />} */}

    </div>
  );
};

// Main component that provides the context
const ProCalculatorMain = ({ activeSection, setActiveSection, ...otherProps }) => {
  return (
    <ProCalculatorProvider 
      activeSection={activeSection} 
      setActiveSection={setActiveSection}
      {...otherProps}
    >
      <ProCalculatorContent />
    </ProCalculatorProvider>
  );
};

export default ProCalculatorMain;
